import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArrowDropDown } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { type MouseEvent, useState } from 'react';

import type { ManualOrderMenuState, ManualOrderMoveAction } from './manualOrder.utils';

type ManualOrderHandleProps = {
  isDragging: boolean;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
  menuState: ManualOrderMenuState;
  onMove: (action: ManualOrderMoveAction) => void;
};

const ManualOrderHandle = ({
  isDragging,
  setActivatorNodeRef,
  attributes,
  listeners,
  menuState,
  onMove,
}: ManualOrderHandleProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleMove = (action: ManualOrderMoveAction) => {
    onMove(action);
    closeMenu();
  };

  return (
    <span className="manual-order-handle">
      <span
        className="manual-order-handle__grip sort-cell-handle"
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        style={{
          cursor: isDragging ? 'grabbing' : 'grab',
        }}
      >
        <FontAwesomeIcon icon={faBars} />
      </span>
      <IconButton
        className="manual-order-menu-btn"
        size="small"
        aria-label="Reorder row"
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={openMenu}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <ArrowDropDown fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}>
        <MenuItem disabled={!menuState.canMoveTop} onClick={() => handleMove('top')}>
          Move to top
        </MenuItem>
        <MenuItem disabled={!menuState.canMoveUp} onClick={() => handleMove('up')}>
          Move up
        </MenuItem>
        <MenuItem disabled={!menuState.canMoveDown} onClick={() => handleMove('down')}>
          Move down
        </MenuItem>
        <MenuItem disabled={!menuState.canMoveBottom} onClick={() => handleMove('bottom')}>
          Move to bottom
        </MenuItem>
      </Menu>
    </span>
  );
};

export default ManualOrderHandle;
